import './styles/syncview.scss'

import React, { Component, Fragment } from 'react'

import ArrowIcon from './../assets/icons/arrow-up.svg'
import ArrowIconWaiting from './../assets/icons/arrow-up-waiting.svg'
import ArrowIconError from './../assets/icons/arrow-up-error.svg'
import CheckIcon from './../assets/icons/check.svg'
import BoxIcon from './../assets/icons/box-data.svg'
import BoxIconWaiting from './../assets/icons/box-data-waiting.svg'
import BoxIconError from './../assets/icons/box-data-error.svg'
import { Tooltip, CircularProgress } from '@material-ui/core'
import { connect } from 'react-redux'
import hasInternet from './../utils/recognizeInternetConnection'
import SyncProblemIcon from '@material-ui/icons/Error'
import RefreshIcon from '@material-ui/icons/Refresh'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import { changeSyncView } from '../redux/sync/actions'
import { SYNC_STATUS, SYNC_STATUS_LABELS } from '../redux/sync/constants'

class SyncView extends Component {
  constructor(props) {
    super(props)
  }

  errorSync = () => (
    <button
      style={{ background: 'none', border: 'none' }}
    >
      <Tooltip title='Dados não enviados' arrow>
        <div style={{ display: 'grid' }} className='syncViewError'>
          <div style={{ position: 'absolute', top: '6px', left: '10px' }}>
            <img
              style={{ position: 'absolute' }}
              src={ArrowIconError}
              width='29'
            />
            {/* <SyncProblemIcon
              style={{ fontSize: '27px', position: 'absolutee', top: '5px', left: '43px' }}
            ></SyncProblemIcon> */}
            <SyncProblemIcon
              style={{ fontSize: '30px', color: 'rgba(255, 34, 5, 0.877)', position: 'absolute', top: '1px', left: '40px' }}
            ></SyncProblemIcon>
            <img
              style={{ position: 'absolute' }}
              src={BoxIconError}
              width='29'
            />
          </div>
        </div>
      </Tooltip>
    </button>
  )

  loadingSync = () => (
    <Tooltip title='Enviando dados...' arrow>
      <div style={{ display: 'grid' }} className='syncView'>
        <div style={{ position: 'absolute', top: '6px', left: '7.5px' }}>
          <img
            style={{ fill: 'green', position: 'absolute' }}
            className='syncViewPushIcon'
            src={ArrowIconWaiting}
            width='29'
          />
          <img
            style={{ position: 'absolute' }}
            src={BoxIconWaiting}
            width='29'
          />
        </div>
      </div>
    </Tooltip>
  )

  successSync = () => (
    <Tooltip title='Dados enviados' arrow>
      <div style={{ display: 'grid' }} className='syncViewSuccess'>
        <div style={{ position: 'absolute', top: '6px', left: '10px' }}>
          <img
            style={{ position: 'absolute' }}
            src={ArrowIcon}
            width='29'
          />
          <img
            style={{ position: 'absolute', top: '5px', left: '43px' }}
            src={CheckIcon}
            width='27'
          />
          <img
            style={{ position: 'absolute' }}
            src={BoxIcon}
            width='29'
          />
        </div>
      </div>
    </Tooltip>
  )

  // Novos estados detalhados para fazendas grandes

  downloadingFarmSync = () => {
    const { progress } = this.props
    const tooltipText = progress?.attempt > 0
      ? `Baixando dados... (tentativa ${progress.attempt}/${progress.maxAttempts || 3})`
      : 'Baixando dados da fazenda...'

    return (
      <Tooltip title={tooltipText} arrow>
        <div style={{ display: 'grid' }} className='syncView syncViewDownloading'>
          <div style={{ position: 'absolute', top: '6px', left: '7.5px' }}>
            <CloudDownloadIcon
              style={{
                fontSize: '28px',
                color: '#1976d2',
                animation: 'pulse 1.5s ease-in-out infinite'
              }}
            />
            <CircularProgress
              size={20}
              thickness={4}
              style={{ position: 'absolute', top: '3px', left: '35px', color: '#1976d2' }}
            />
          </div>
        </div>
      </Tooltip>
    )
  }

  processingSync = () => (
    <Tooltip title='Processando registros...' arrow>
      <div style={{ display: 'grid' }} className='syncView'>
        <div style={{ position: 'absolute', top: '6px', left: '7.5px' }}>
          <img
            style={{ fill: 'green', position: 'absolute' }}
            className='syncViewPushIcon'
            src={ArrowIconWaiting}
            width='29'
          />
          <CircularProgress
            size={18}
            thickness={5}
            style={{ position: 'absolute', top: '5px', left: '40px', color: '#4caf50' }}
          />
          <img
            style={{ position: 'absolute' }}
            src={BoxIconWaiting}
            width='29'
          />
        </div>
      </div>
    </Tooltip>
  )

  retryingSync = () => {
    const { progress } = this.props
    const tooltipText = progress?.attempt > 0
      ? `Tentando novamente... (${progress.attempt}/${progress.maxAttempts || 3})`
      : 'Erro - tentando novamente...'

    return (
      <Tooltip title={tooltipText} arrow>
        <div style={{ display: 'grid' }} className='syncViewRetrying'>
          <div style={{ position: 'absolute', top: '6px', left: '10px' }}>
            <RefreshIcon
              style={{
                fontSize: '28px',
                color: '#ff9800',
                animation: 'spin 1s linear infinite'
              }}
            />
            <span style={{
              position: 'absolute',
              top: '2px',
              left: '32px',
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#ff9800'
            }}>
              {progress?.attempt || '?'}/{progress?.maxAttempts || 3}
            </span>
          </div>
        </div>
      </Tooltip>
    )
  }

  getCurrentSyncStatus() {
    const { currentSync } = this.props

    // Verificar conexão primeiro
    if (!hasInternet()) {
      return this.errorSync()
    }

    // Mapear status para componentes
    switch (currentSync) {
      case SYNC_STATUS.ERROR:
        return this.errorSync()

      case SYNC_STATUS.SYNCING:
        return this.loadingSync()

      case SYNC_STATUS.SUCCESS:
        return this.successSync()

      case SYNC_STATUS.DOWNLOADING_FARM:
        return this.downloadingFarmSync()

      case SYNC_STATUS.PROCESSING:
        return this.processingSync()

      case SYNC_STATUS.RETRYING:
        return this.retryingSync()

      default:
        // Fallback para comportamento legado
        if (currentSync == 0) return this.errorSync()
        if (currentSync == 1) return this.loadingSync()
        if (currentSync == 2) return this.successSync()
        return this.loadingSync()
    }
  }

  render() {
    return <Fragment> {this.getCurrentSyncStatus()} </Fragment>
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeSyncView: payload => dispatch(changeSyncView(payload))
  }
}

const mapStateToProps = state => ({
  currentSync: state.sync.currentSync,
  progress: state.sync.progress
})

export default connect(mapStateToProps, mapDispatchToProps)(SyncView)
